import { type CSSProperties } from 'react'
import { motion } from 'framer-motion'
import { cn } from '@/lib/utils'

type CtaSectionProps = {
  isHomePage?: boolean
}

export function CtaSection({ isHomePage = false }: CtaSectionProps) {
  return (
    <section
      id="contact"
      className={cn(
        'bg-[#FAFAFA] pt-16 pb-10 sm:pt-24 sm:pb-12 xl:pt-[150px] xl:pb-[150px]',
        !isHomePage && 'mt-16 sm:mt-24 xl:mt-[150px]',
      )}
      aria-labelledby="cta-heading"
    >
      <div className="container-site">
        <motion.div
          className="mx-auto w-full max-w-[763px] text-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.55, ease: 'easeOut' }}
        >
          <h2
            id="cta-heading"
            className="text-center font-sans text-[28px] font-medium not-italic leading-[36px] tracking-[-1px] text-[#2D2D2D] sm:text-[36px] sm:leading-[44px] xl:text-[48px] xl:leading-[55px]"
          >
            Let&apos;s Build What&apos;s Next.
          </h2>
          <p className="mt-3 w-full text-center font-sans text-[22px] font-normal not-italic leading-[30px] tracking-[-1px] text-[#8387B9] sm:text-[30px] sm:leading-[38px] xl:text-[48px] xl:leading-[55px]">
            Tell us what you&apos;re building — we&apos;ll help you plan, design, and scale it.
          </p>
          <div className="mt-6 flex justify-center sm:mt-8 xl:mt-10">
            <a
              href="/contact"
              className="flex items-center justify-center gap-[10px] rounded-[10px] border border-[rgba(41,41,41,0.09)] bg-[#302F2F] px-4 py-2.5 text-center font-sans text-[14px] font-normal not-italic leading-normal text-white transition-colors hover:bg-[#3d3c3c] sm:px-5 sm:py-3 sm:text-[16px] xl:text-[18px]"
              style={
                {
                  leadingTrim: 'both',
                  textEdge: 'cap',
                } as CSSProperties
              }
            >
              Start your project
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  )
}
